import React, { useMemo, useEffect } from 'react';
import { useFormResponseStore } from '@/store';

interface AddVideoProps {
  question: any;
  sectionId: string;
  sectionName: string;
}

export const AddVideoAnswer: React.FC<AddVideoProps> = ({ question, sectionId, sectionName }) => {
  const { setResponse } = useFormResponseStore();
  const videoContent = useMemo(() => {
    return { __html: question.video };
  }, [question.video]);

  useEffect(() => {
    if (question.video) {
      setResponse(
        sectionId,
        sectionName,
        question.id,
        question.type,
        question.label || '',
        {
          video: question.video
        }
      );
    }
  }, [question.id, question.type, question.label, question.video, sectionId, sectionName, setResponse]);

  return (
    <div className="mb-4 max-w-screen-lg mx-auto aspect-w-16 aspect-h-9">
      <div className="video-container" dangerouslySetInnerHTML={videoContent} />
    </div>
  );
};